<ng-lottie [options]="options" (animationCreated)="animationCreated($event)" style="width: 8%; height: auto;">
</ng-lottie>